import { render } from "./cards-posts-list.vue?vue&type=template&id=7f699f80"
import script from "./cards-posts-list.vue?vue&type=script&lang=js"
export * from "./cards-posts-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__